import $ from 'jquery';

const megaMenu = () => {
    const $desktopMenu = $('.desktop-menu');
    const $megaMenuContainer = $('.mega-menu-container');
    const $desktopHeaderContentWidth = $('.desktop-header-content').width();

    $megaMenuContainer.width($desktopHeaderContentWidth);

    const hideMegaMenu = () => {
        $desktopMenu.removeClass('animate-mega-menu');
        $desktopMenu.find('.is-active').removeClass('is-active');
        $desktopMenu.find('a.has-child').attr('aria-expanded', 'false');
        $desktopMenu.find('.desktop-mega-menu.is-active').removeClass('is-active');
        $('.js-overlay').css('height', 0);
    };

    const showMegaMenu = el => {
        const $currentContent = $desktopMenu.find(`.desktop-mega-menu[data-id="${el.data('id')}"]`);

        if (el.hasClass('is-active')) {
            hideMegaMenu();
            return;
        }
        if ($desktopMenu.find('a.nav-item.is-active')) {
            hideMegaMenu();
        }
        if (el.hasClass('has-child')) {
            el.addClass('is-active');
            el.attr('aria-expanded', 'true');
            $desktopMenu.addClass('animate-mega-menu');
            $('.js-overlay').css('height', window.innerHeight);

            $currentContent.addClass('is-active');
        }
    };

    $desktopMenu.on('click', 'a.nav-item.has-child', function (e) {
        e.preventDefault();
        showMegaMenu($(this));
    });

    $(document).on('click', '.js-overlay', e => {
        e.stopPropagation();
        hideMegaMenu();
    });

    $(document).on('click', e => {
        // Don't close if clicking inside mega menu
        if ($(e.target).closest('.desktop-mega-menu').length > 0) {
            return;
        }

        // Close menu if clicking outside both desktop-menu and desktop-mega-menu
        const $target = $(e.target);
        if (!$target.closest('.desktop-menu').length && !$target.closest('.desktop-mega-menu').length) {
            hideMegaMenu();
        }
    });

    // Handle keyboard navigation - close menu when focus leaves both menu and mega menu
    $desktopMenu.on('focusout', e => {
        const $relatedTarget = $(e.relatedTarget);

        if (!e.relatedTarget
            || $desktopMenu.find($relatedTarget).length > 0
            || $relatedTarget.closest('.desktop-mega-menu').length > 0) {
            return;
        }

        hideMegaMenu();
    });

    $('.s-desktop-header').on('focusout', '.desktop-mega-menu', e => {
        const $relatedTarget = $(e.relatedTarget);

        if (!e.relatedTarget
            || $relatedTarget.closest('.desktop-mega-menu').length > 0
            || $relatedTarget.closest('.desktop-menu').length > 0) {
            return;
        }

        hideMegaMenu();
    });
};

$(() => {
    const $widget = $('.s-desktop-header');
    if ($widget.length) {
        $('body').append($('<span class="overlay js-overlay"></span>'));
        $widget.each(function () {
            megaMenu($(this));
        });
    }
});
